/**
 * DiscriminatorValue properties.
 */
export interface DiscriminatorValueMetadataArgs {

    /**
     * Class to which discriminator name is applied.
     */
    readonly target: Function|string;

    /**
     * Discriminator value.
     */
    readonly value: any;

}
